import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Third party packages
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { SuppliersService } from 'src/app/modules/suppliers/suppliers.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { CreditsafeService } from 'src/app/shared/services/creditsafe.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import { OpenapiService } from 'src/app/shared/services/openapi.service';
var AddSupplierDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function AddSupplierDialogComponent(dialogRef, data, configService, cookieService, toastrService, translateService, suppliersService, authService, helperService, openapiService, creditsafeService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.cookieService = cookieService;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.suppliersService = suppliersService;
        this.authService = authService;
        this.helperService = helperService;
        this.openapiService = openapiService;
        this.creditsafeService = creditsafeService;
        this.subscriptions = [];
        this.loggedUserRoleType = '';
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add employee form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.create'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-save',
                inline: true,
            },
        };
        // END - Add employee form
        this.dialogIsLoading = true;
        this.dataFromOpenApi = false;
        this.suppliersFromOpenApi = [];
        dialogRef.disableClose = true;
    }
    /**
     * Init component
     *
     * @returns undefined
     */
    AddSupplierDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
            var currentRole = _this.loggedUser.userRoles.find(function (obj) {
                return (obj._id.toString() ===
                    _this.authService.loggedUserRequestedRole$.getValue().toString());
            });
            _this.loggedUserRole = currentRole.role;
            _this.loggedUserRoleType = _this.loggedUserRole.type;
        }));
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        // Init add form
        this.initForm();
        // Stop loading dialog
        this.dialogIsLoading = false;
    };
    /**
     * Handle component destroy
     *
     * @returns undefined
     */
    AddSupplierDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    AddSupplierDialogComponent.prototype.initForm = function () {
        var e_1, _a;
        // Set model
        this.model = {};
        var categoriesOptions = [];
        var rawCategories = this.translateService.instant('suppliers.categories');
        try {
            for (var _b = tslib_1.__values(Object.keys(rawCategories)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var trans = _c.value;
                categoriesOptions.push({
                    label: rawCategories[trans],
                    value: trans,
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Set fields
        this.fields = [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        key: "status",
                        templateOptions: {
                            type: "hidden",
                        },
                    },
                    {
                        key: "notRegistered",
                        defaultValue: false,
                        templateOptions: {
                            type: "hidden",
                        },
                    },
                    {
                        key: "openApiId",
                        templateOptions: {
                            type: "hidden",
                        },
                    },
                    {
                        key: "startCompanyDate",
                        templateOptions: {
                            type: "hidden",
                        },
                    },
                    {
                        className: 'col-12',
                        type: 'input',
                        key: 'name',
                        defaultValue: (this.data && this.data.name) ? this.data.name : '',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.name'),
                            placeholder: this.translateService.instant('suppliers.fields.name'),
                            required: true,
                            minLength: 2,
                            maxLength: 100,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'input',
                        key: 'vatNumber',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.vatNumber'),
                            placeholder: this.translateService.instant('suppliers.fields.vatNumber'),
                            required: false,
                            minLength: 0,
                            maxLength: 20,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'input',
                        key: 'taxCode',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.taxCode'),
                            placeholder: this.translateService.instant('suppliers.fields.taxCode'),
                            required: false,
                            minLength: 0,
                            maxLength: 20,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'address',
                        key: 'legalAddress',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.legalAddress'),
                            placeholder: this.translateService.instant('suppliers.fields.legalAddress'),
                            required: false,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'address',
                        key: 'operativeAddress',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.operativeAddress'),
                            placeholder: this.translateService.instant('suppliers.fields.operativeAddress'),
                            required: false,
                        },
                    },
                    {
                        className: 'col-12',
                        type: 'select',
                        key: 'categories',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.categories'),
                            placeholder: this.translateService.instant('suppliers.fields.categories'),
                            multiple: true,
                            options: categoriesOptions,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'input',
                        key: 'contactPerson',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.contactPerson'),
                            placeholder: this.translateService.instant('suppliers.fields.contactPerson'),
                            required: false,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'input',
                        key: 'email',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.email'),
                            placeholder: this.translateService.instant('suppliers.fields.email'),
                            required: false,
                            minLength: 5,
                            maxLength: 320,
                            type: 'email',
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'input',
                        key: 'pec',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.pec'),
                            placeholder: this.translateService.instant('suppliers.fields.pec'),
                            required: false,
                            minLength: 5,
                            maxLength: 320,
                            type: 'email',
                        },
                    },
                    {
                        className: 'col-12 col-md-4',
                        type: 'input',
                        key: 'phone',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.phone'),
                            placeholder: this.translateService.instant('suppliers.fields.phone'),
                            required: false,
                            minLength: 1,
                            maxLength: 15,
                            pattern: this.configService.phonePattern,
                        },
                    },
                    {
                        className: 'col-12 col-md-4',
                        type: 'input',
                        key: 'fax',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.fax'),
                            placeholder: this.translateService.instant('suppliers.fields.fax'),
                            required: false,
                            minLength: 1,
                            maxLength: 15,
                            pattern: this.configService.phonePattern,
                        },
                    },
                    {
                        className: 'col-12 col-md-4',
                        type: 'input',
                        key: 'webSiteUrl',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.fields.webSiteUrl'),
                            placeholder: this.translateService.instant('suppliers.fields.webSiteUrl'),
                            required: false,
                            minLength: 1,
                            maxLength: 100,
                            pattern: this.configService.webSitePattern,
                        },
                    },
                ],
            },
        ];
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     * @author Francesco Bancalari <francesco.bancalari@sitisrl.it>
     *
     * @param [data] optional data passed to the caller component
     * @returns void
     */
    AddSupplierDialogComponent.prototype.onClose = function (data) {
        this.dialogRef.close(data);
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    AddSupplierDialogComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
            return;
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        var sendData = JSON.parse(JSON.stringify(model));
        // adjust the phone type
        sendData.phone = {
            prefix: "",
            number: sendData.phone
        };
        this.subscriptions.push(
        // this.suppliersService.create(model) @TODO
        this.suppliersService.createV2(sendData)
            .pipe(finalize(function () { return _this.formBtnOptions.active = false; }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                res.supplier = res.data; //  @TODO
                res.supplier.name = res.data.companyName; //  @TODO
                _this.onClose(res);
                return;
            }
            // this.toastrService.error(this.translateService.instant('common.errors.unknown_server_error'));
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Handle serach supplier data from externla search
     */
    AddSupplierDialogComponent.prototype.onExternalSearch = function () {
        var _this = this;
        if (this.model.vatNumber || this.model.name) {
            this.dialogIsLoading = true;
            this.suppliersFromOpenApi = [];
            this.dataFromOpenApi = true;
            if (this.model.vatNumber) {
                this.subscriptions.push(this.creditsafeService.getCompanyByVatNumber(this.model.vatNumber).subscribe(function (res) {
                    if (res && res.status && res.data) {
                        var items = [];
                        items.push({
                            companyName: res.data.name,
                            vatCode: (Array.isArray(res.data.vatNo) && res.data.vatNo.length) ? res.data.vatNo[0] : res.data.vatNo,
                            address: res.data.address,
                            phone: (Array.isArray(res.data.phoneNumbers) && res.data.phoneNumbers.length) ? res.data.phoneNumbers[0] : '',
                        });
                        _this.suppliersFromOpenApi = items;
                    }
                    _this.dialogIsLoading = false;
                }, function (err) {
                    _this.dialogIsLoading = false;
                    _this.helperService.handleError(err);
                }));
            }
            else if (this.model.name) {
                this.subscriptions.push(this.creditsafeService.getCompanyByCompanyName(this.model.name).subscribe(function (res) {
                    var e_2, _a;
                    if (res && res.status && res.data && Array.isArray(res.data)) {
                        var items = [];
                        try {
                            for (var _b = tslib_1.__values(res.data), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var item = _c.value;
                                items.push({
                                    companyName: item.name,
                                    vatCode: (Array.isArray(item.vatNo) && item.vatNo.length) ? item.vatNo[0] : item.vatNo,
                                    address: item.address,
                                    phone: (Array.isArray(item.phoneNumbers) && item.phoneNumbers.length) ? item.phoneNumbers[0] : '',
                                });
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        _this.suppliersFromOpenApi = items;
                    }
                    _this.dialogIsLoading = false;
                }, function (err) {
                    _this.dialogIsLoading = false;
                    _this.helperService.handleError(err);
                }));
            }
        }
    };
    // /**
    //  * Handle serach supplier data from externla search
    //  */
    // onExternalSearch(): void {
    //   if (this.model.vatNumber || this.model.name) {
    //     this.dialogIsLoading = true;
    //     this.suppliersFromOpenApi = [];
    //     let token = '';
    //     this.dataFromOpenApi = true;
    //     this.subscriptions.push(
    //       this.openapiService.getValidToken().subscribe(
    //         res => {
    //           token = res;
    //           if (this.model.vatNumber) {
    //             this.subscriptions.push(
    //               this.openapiService.getCompanyByVatNumber(token, this.model.vatNumber).subscribe(
    //                 res => {
    //                   if (res) {
    //                     this.suppliersFromOpenApi = res;
    //                   }
    //                   this.dialogIsLoading = false;
    //                 },
    //                 err => {
    //                   this.dialogIsLoading = false;
    //                   this.helperService.handleError(err);
    //                 }
    //               )
    //             );
    //           } else if (this.model.name) {
    //             this.subscriptions.push(
    //               this.openapiService.getCompanyByCompanyName(token, this.model.name).subscribe(
    //                 res => {
    //                   if (res) {
    //                     this.suppliersFromOpenApi = res;
    //                   }
    //                   this.dialogIsLoading = false;
    //                 },
    //                 err => {
    //                   this.dialogIsLoading = false;
    //                   this.helperService.handleError(err);
    //                 }
    //               )
    //             );
    //           }
    //         },
    //         err => {
    //           this.dialogIsLoading = false;
    //           this.helperService.handleError(err);
    //         }
    //       )
    //     );
    //   } 
    // }
    /**
     * Handle select supplier
     * @param item
     */
    AddSupplierDialogComponent.prototype.onSelectedItem = function (item) {
        var nameControl = this.form.controls.name;
        var vatNumberControl = this.form.controls.vatNumber;
        var taxCodeControl = this.form.controls.taxCode;
        var legalAddressControl = this.form.controls.legalAddress;
        var phoneControl = this.form.controls.phone;
        var openApiIdControl = this.form.controls.openApiId;
        var pecControl = this.form.controls.pec;
        var startCompanyDateControl = this.form.controls.startCompanyDate;
        var statusControl = this.form.controls.status;
        var notRegisteredControl = this.form.controls.notRegistered;
        // 'sdiCode', item.sdiCode
        nameControl.setValue(item.companyName);
        vatNumberControl.setValue(item.vatCode ? item.vatCode : '');
        taxCodeControl.setValue(item.taxCode ? item.taxCode : '');
        phoneControl.setValue(item.phone ? item.phone : '');
        if (item.address) {
            var address = {
                route: item.address.street,
                streetNumber: item.address.houseNo,
                postalCode: item.address.postCode,
                city: item.address.city,
                administrativeArea1: '',
                administrativeArea2: item.address.province,
                administrativeArea3: item.address.city,
                countryCodeTwo: "IT",
            };
            legalAddressControl.setValue(address);
        }
        // openApiIdControl.setValue(item.id);
        // pecControl.setValue(item.pec);
        // if (moment(item.startDate).isValid()) {
        //   startCompanyDateControl.setValue(`${item.startDate}T00:00:00.000Z`);
        // }
        // switch (item.activityStatus) {
        //   case 'ATTIVA': statusControl.setValue('active'); break;
        //   case 'REGISTRATA': statusControl.setValue('registered'); break;
        //   case 'INATTIVA': statusControl.setValue('inactive'); break;
        //   case 'SOSPESA': statusControl.setValue('suspended'); break;
        //   case 'IN_ISCRIZIONE': statusControl.setValue('inRegistration'); break;
        //   case 'CESSATA': statusControl.setValue('ceased'); break;
        //   default: {
        //     statusControl.setValue('notDefined');
        //     notRegisteredControl.setValue(true);
        //   }
        // }
    };
    return AddSupplierDialogComponent;
}());
export { AddSupplierDialogComponent };
